import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch, useHistory } from 'react-router';
import { useUrlGenerator } from '@folklore/react-container';

// import * as AppPropTypes from '../lib/PropTypes';
import { resetRequest as resetRequestAction } from '../actions/SiteActions';
// import MainLayout from './layouts/Main';
import Page from './Page';
import ErrorPage from './pages/Error';

import '../../styles/main.global.scss';

const propTypes = {
    resetRequest: PropTypes.func.isRequired,
};

const defaultProps = {};

const App = ({ resetRequest }) => {
    const history = useHistory();
    const urlGenerator = useUrlGenerator();

    // Reset request on history change
    useEffect(() => {
        const unlisten = history.listen(() => {
            if (window) {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            }
            resetRequest();
        });

        return () => {
            unlisten();
        };
    }, [history]);

    return (
        <Switch>
            <Route exact path={urlGenerator.route('home.fr')} component={Page} />
            <Route exact path={urlGenerator.route('season.fr')} component={Page} />
            <Route exact path={urlGenerator.route('event.fr')} component={Page} />
            <Route exact path={urlGenerator.route('notebookspage.fr')} component={Page} />
            <Route exact path={urlGenerator.route('notebookstags.fr')} component={Page} />
            <Route exact path={urlGenerator.route('notebookstagspage.fr')} component={Page} />
            <Route exact path={urlGenerator.route('notebooks.fr')} component={Page} />
            <Route exact path={urlGenerator.route('notebook.fr')} component={Page} />
            <Route exact path={urlGenerator.route('withparent.fr')} component={Page} />
            <Route exact path={urlGenerator.route('page.fr')} component={Page} />
            <Route path="*" component={ErrorPage} />
        </Switch>
    );
};

App.propTypes = propTypes;
App.defaultProps = defaultProps;

const WithStateContainer = connect(
    null,
    dispatch => ({
        resetRequest: () => dispatch(resetRequestAction()),
    }),
)(App);
export default WithStateContainer;
